import { api } from '@services';

import { TaskPriorityOptions, TaskStatusOptions } from '@models/Task.model';

interface IPatchTask {
  taskId: string;
  title?: string;
  description?: string;
  status?: TaskStatusOptions | null;
  priority?: TaskPriorityOptions | null;
  dueDate?: Date | null;
  assigneeId?: string | null;
}

const patchTask = async ({ taskId, ...rest }: IPatchTask): Promise<void> => {
  await api.patch(`/tasks/${taskId}`, rest);
};

export { patchTask };
